export enum CustomSignaturesConstants {
  SET_CUSTOM_SIGNATURE_TRANSFORMED_OPTIONS = 'customSignatures/SET_CUSTOM_SIGNATURE_TRANSFORMED_OPTIONS',
  SET_CUSTOM_SIGNATURE_CURRENT_SELECTED_OPTION = 'customSignatures/SET_CUSTOM_SIGNATURE_CURRENT_SELECTED_OPTION',
  SET_CUSTOM_SIGNATURE_SIGNING_REASON = 'customSignatures/SET_CUSTOM_SIGNATURE_SIGNING_REASON',
  SET_CUSTOM_SIGNATURE_SIGNATORY_NAME = 'customSignatures/SET_CUSTOM_SIGNATURE_SIGNATORY_NAME',
  SET_CUSTOM_SIGNATURE_SIGNATORY_RELATION = 'customSignatures/SET_CUSTOM_SIGNATURE_SIGNATORY_RELATION',
  SET_CUSTOM_SIGNATURE_SIGNATORY_PHONE = 'customSignatures/SET_CUSTOM_SIGNATURE_SIGNATORY_PHONE',
  SET_CUSTOM_SIGNATURE_COUNTER = 'customSignatures/SET_CUSTOM_SIGNATURE_COUNTER',
  SAVE_TEMP_SIGNATURE = 'customSignatures/SAVE_TEMP_SIGNATURE',
  SAVE_CUSTOM_SIGNATURE = 'customSignatures/SAVE_CUSTOM_SIGNATURE',
  SAVE_CUSTOM_SIGNATURE_TO_PCR = 'customSignatures/SAVE_CUSTOM_SIGNATURE_TO_PCR',
  SAVE_PR_FORMS_CUSTOM = 'customSignatures/SAVE_PR_FORMS_CUSTOM',
  ADD_CUSTOM_SIGNATURE = 'customSignatures/ADD_CUSTOM_SIGNATURE',
  SET_SELECTED_CHECKBOX = 'customSignatures/SET_SELECTED_CHECKBOX',
  SET_CUSTOM_SIGNATURE_TERM = 'customSignatures/SET_CUSTOM_SIGNATURE_TERM',
  SET_CUSTOM_SIGNATURE_ACKNOWLEDGED_PRIVACY_NOTICES = 'customSignatures/SET_CUSTOM_SIGNATURE_ACKNOWLEDGED_PRIVACY_NOTICES',
  SET_SIGNED_CUSTOM_SIGNATURE = 'customSignatures/SET_SIGNED_CUSTOM_SIGNATURE',
  RESET_CUSTOM_SIGNATURE_CLIENT_DATA = 'customSignatures/RESET_CUSTOM_SIGNATURE_CLIENT_DATA',
  LOAD_CUSTOM_SIGNATURE_DATA = 'customSignatures/LOAD_CUSTOM_SIGNATURE_DATA',
  SET_DELETE_CHIP_ID = 'customSignatures/SET_DELETE_CHIP_ID',
  CUSTOM_SIGNATURE_CLEAR_ALL = 'customSignatures/CUSTOM_SIGNATURE_CLEAR_ALL',
  SAVE_CUSTOM_SIGNATURE_CLIENT_DATA = 'customSignatures/SAVE_CUSTOM_SIGNATURE_CLIENT_DATA',
  SET_SIGNATURE_TYPE = 'customSignatures/SET_SIGNATURE_TYPE',
  RESET_CUSTOM_SIGNATURE = 'customSignatures/RESET_CUSTOM_SIGNATURE',
}
